export default "__VITE_ASSET__KOX485Mv__"